import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const SocialMediaYoutube = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M19.5 14.423V9.077s0-2.577-2.585-2.577h-9.83S4.5 6.5 4.5 9.077v5.346S4.5 17 7.084 17h9.831s2.585 0 2.585-2.577m-4.588-2.666l-4.91 2.875v-5.75l4.91 2.875"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)
